<iframe
    class="iframe-livetracker-app"
    [src]="linkLiveTracker"
    name="myiFrame"
    scrolling="no"
    frameborder="0">
</iframe>
